import Routes from 'components/Routes';

import { connect } from 'react-redux';
import * as Store from 'modules/index';
import { authenticateUser } from 'modules/Cache';

const mapState = (state: Store.State) => ({
  accessToken: state.cache.accessToken,
});

const mapDispatch = {
  login: (username: string, password: string) => {
    return authenticateUser({username, password});
  },
};

const connector = connect(mapState, mapDispatch);

export default connector(Routes);

